export enum GuestActionTypes {
    SET_CONTACT_INFORMATION = 'GUEST_SET_CONTACT_INFORMATION',
    RESET_GUEST_STATE = 'GUEST_RESET_GUEST_STATE'
}
